import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export interface InterviewerPool {
  category: 'ats_interviewer_pool';
  id: number;
  members_count: number;
  name: string;
}

interface GetInterviewerPoolsApiResponse {
  data: InterviewerPool[];
  errors: string[];
}

export const useGetAllInterviewerPools = () => {
  const query = useQuery<GetInterviewerPoolsApiResponse, Error>({
    queryKey: ['get-all-interviewer-pools'],
    queryFn: async () => {
      const res = await http.get<GetInterviewerPoolsApiResponse>(
        'user_groups?type=ats_interviewer_pool'
      );
      // Interceptor unwraps `response.data`; axios typings still return AxiosResponse<T>
      return res as unknown as GetInterviewerPoolsApiResponse;
    },
    staleTime: 0,
  });

  const interviewerPools = query?.data?.data ?? [];
  const uiError = query?.data?.errors ?? [];

  return { interviewerPools, uiError, ...query };
};
